import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import EventView from "./SubjectDataEventView"
import RouteView from "./SubjectDataRouteView"
import "./SubjectData.css"


const SubjectDataParser = ({ user, post, onDeletePost }) => {

    useEffect(() => {
      
    }, [])

    return (
        <React.Fragment>
            {
                (() => {
                    switch (post.subjectDataType) {
                        case "JustGoRide.Web.Models.User.SharedRoutePost":
                            return (
                                <RouteView post={post} onDeletePost={onDeletePost} mode="shared" />
                            )
                        case "JustGoRide.Web.Models.User.RouteUploadPost":
                            return (
                                <RouteView post={post} onDeletePost={onDeletePost} mode="upload" />
                            )
                        case "JustGoRide.Web.Models.User.EventPost":
                            return (
                                <EventView post={post} onDeletePost={onDeletePost} />
                            )
                        default:
                            return null;
                    }
                })()
            }
        </React.Fragment>
    )
};

SubjectDataParser.propTypes = {
    user: PropTypes.object.isRequired,
    post: PropTypes.object.isRequired,
    onDeletePost: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps)(SubjectDataParser); 




// WEBPACK FOOTER //
// ./src/components/postComments/SubjectDataParser.js